module.exports = __webpack_public_path__ + "static/media/pinkheart.f49865f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile-icons/pinkheart.svg
// module id = 1113
// module chunks = 31